import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, Avatar, Box, Button, IconButton, TextField } from '@mui/material';
import React from 'react';

const SearchInviteSection = ({
  selectedProfiles,
  options,
  inputValue,
  onSelectedChange,
  onInputChange,
  onSubmit,
  isSubmitting,
  classes,
  t,
}) => {
  return (
    <div className={classes.searchSection}>
      <div className={classes.searchSectionContent}>
        <Autocomplete
          multiple
          options={options}
          filterOptions={(x) => x}
          value={selectedProfiles}
          onChange={onSelectedChange}
          inputValue={inputValue}
          onInputChange={(_, value) => onInputChange(value)}
          getOptionLabel={(option) => {
            if (option.legal_name && option.name) {
              return `${option.legal_name} [${option.name}]`;
            }
            if (option.name) {
              return option.name;
            }
            if (option.email) {
              return option.email;
            }
            if (option.legal_name) {
              return option.legal_name;
            }
            return option.uuid || '';
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          className={classes.searchBox}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => {
              const tagProps = getTagProps({ index });
              const getLabel = (opt) => {
                if (opt.legal_name && opt.name) {
                  return `${opt.legal_name} [${opt.name}]`;
                }
                if (opt.name) {
                  return opt.name;
                }
                if (opt.email) {
                  return opt.email;
                }
                if (opt.legal_name) {
                  return opt.legal_name;
                }
                return opt.uuid || '';
              };
              const label = getLabel(option);

              return (
                <Box
                  key={tagProps.key}
                  className={classes.selectedUserTag}
                >
                  <Avatar
                    className={classes.selectedUserTagAvatar}
                    src={option?.avatar || option?.profile_image || option?.image || ''}
                  >
                    {(option?.name || option?.legal_name || option?.uuid || '').slice(0, 1)}
                  </Avatar>
                  <Box className={classes.selectedUserTagLabel}>{label}</Box>
                  <IconButton
                    className={classes.selectedUserTagRemove}
                    onClick={tagProps.onDelete}
                    size="small"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              );
            })
          }
          renderOption={(props, option) => {
            const getLabel = (opt) => {
              if (opt.legal_name && opt.name) {
                return `${opt.legal_name} [${opt.name}]`;
              }
              if (opt.name) {
                return opt.name;
              }
              if (opt.email) {
                return opt.email;
              }
              if (opt.legal_name) {
                return opt.legal_name;
              }
              return opt.uuid || '';
            };
            const label = getLabel(option);
            return (
              <li {...props}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Avatar
                    src={option?.avatar || option?.profile_image || option?.image || ''}
                    sx={{ width: 24, height: 24 }}
                  >
                    {(option?.name || option?.legal_name || option?.uuid || '').slice(0, 1)}
                  </Avatar>
                  <Box>{label}</Box>
                </Box>
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={t('search')}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <div className={classes.searchEndAdornment}>
                    <SearchIcon />
                  </div>
                ),
              }}
            />
          )}
        />
      </div>

      <Button
        variant="contained"
        color="primary"
        className={classes.inviteButton}
        onClick={onSubmit}
        disabled={isSubmitting || selectedProfiles.length === 0}
      >
        {isSubmitting ? t('processing') : t('invite')}
      </Button>
    </div>
  );
};

export default SearchInviteSection;
